import { resetAnalyticsUser } from "./analytics";
import { apiCall } from "./api";
import { getCookie } from "./utils";

const ADMIN_AUTH_ROUTES = {
  passwordless: "/api/v1/passwordless-a",
  otp: "/api/v1/otp-a",
  profile: "/api/v1/profile-a",
  logout: "/api/v1/logout",
};

export const generateOTP = (email) => {
  return apiCall(ADMIN_AUTH_ROUTES.passwordless, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      nootp: localStorage.getItem("nootp") || false,
    },
    body: JSON.stringify({ email: email }),
  });
};

export const validateOtp = (email, otp, referralCode) => {
  const data = {
    email,
    otp,
  };
  if (referralCode) {
    data["referralCode"] = referralCode;
  }
  return apiCall(ADMIN_AUTH_ROUTES.otp, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify(data),
  });
};

export const getProfile = () => {
  const url = ADMIN_AUTH_ROUTES.profile;
  return apiCall(
    url,
    {
      method: "GET",
      headers: {},
      credentials: "include",
    },
    "USER_PROFILE",
  );
};

export const updateProfileData = (data) => {
  const body = new FormData();
  for (const key in data) {
    body.append(key, data[key]);
  }
  const url = "/api/v1/profile";
  return apiCall(
    url,
    {
      method: "PUT",
      headers: {},
      body,
      credentials: "include",
    },
    "UPDATE_PROFILE",
  );
};

export const getAllResources = () => {
  return apiCall("/api/v1/resource", {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });
};

export const impersonateUser = (email) => {
  return apiCall("/api/v1/admin/impersonate", {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify({ email }),
  });
};

export const getAllUsers = () => {
  return apiCall("/api/v1/users-manage", {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    credentials: "include",
  });
};

export const getAllUserNames = () => {
  return apiCall("/api/v1/get-all-users", {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    credentials: "include",
  });
};

export const removeUsers = (workspaceId, data) => {
  return apiCall(`/api/v1/workspace/${workspaceId}/remove-users`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify(data),
  });
};

export const promoteAsAdmin = (workspaceId, data) => {
  return apiCall(`/api/v1/workspace/${workspaceId}/promote-as-admin`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify(data),
  });
};

export const logoutUser = () => {
  resetAnalyticsUser();
  return apiCall(ADMIN_AUTH_ROUTES.logout, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    credentials: "include",
  });
};

export const getUsers = (workspaceId) => {
  return apiCall(`/api/v1/workspace/${workspaceId}/users-manage`, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    credentials: "include",
  });
};

export const changeUserRole = (workspaceId, data) => {
  return apiCall(`/api/v1/workspace/${workspaceId}/change-user-role`, {
    method: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    credentials: "include",
    body: JSON.stringify(data),
  });
};

export const getUserName = (storeId) => {
  const url = "/api/v1/username?storeId=" + storeId;
  return apiCall(
    url,
    {
      method: "GET",
      headers: {},
    },
    "USER_NAME",
  );
};

export const getWorkspaceNames = (workspaceId) => {
  const url = "/api/v1/workspace-usernames?workspaceId=" + workspaceId;
  return apiCall(
    url,
    {
      method: "GET",
      headers: {},
    },
    "WORKSPACE_USER_NAME",
  );
};

export const updateLastActiveWsStore = (workspaceId, storeId) => {
  const url = "/api/v1/update-last-active-ws-store";
  const body = {};
  if (workspaceId) {
    body["lastActiveWorkspaceId"] = workspaceId;
  }
  body["lastActiveStoreId"] = storeId;
  return apiCall(
    url,
    {
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(body),
      credentials: "include",
    },
    "USER_PROFILE",
  );
};

export const getFeatureFlags = () => {
  const url = "/api/v1/feature-flags";
  return apiCall(url, { method: "GET" }, "FEATURE_FLAGS");
};

export const handleCloseReleaseNotificationWindow = () => {
  return apiCall("/api/v1/set-release-notification-status", {
    method: "PUT",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ status: false }),
  });
};

export const getUserDetail = (workspaceId, userId) => {
  return apiCall(`/api/v1/workspace/${workspaceId}/users/${userId}`, {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    credentials: "include",
  });
};
